import { Tooltip } from 'antd';
export const config = {
  rowSelection: false,
  rowKey: 'kind',
  columns: [
    {
      title: '费用项',
      dataIndex: 'itemName',
      width: 200,
      ellipsis: {
        showTitle: true,
      },
    },
    {
      title: '所属类目',
      dataIndex: 'categoryTypeName',
      width: 200,
      ellipsis: {
        showTitle: true,
      },
    },
    {
      title: '报价类型',
      dataIndex: ['quoteTypeName'],
      width: 200,
      ellipsis: {
        showTitle: true,
      },
    },
    {
      title: '计算方式',
      dataIndex: 'commonFormulaStr',
      width: 500,
      ellipsis: {
        showTitle: true,
      },
      render: (text) => (
        <Tooltip title={text}>
          <div style={{ width: 500, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{ text }</div>
        </Tooltip>
      )
    },
    {
      title: '适用门店',
      dataIndex: 'shops',
      width: 500,
      ellipsis: {
        showTitle: true,
      },
      render: (text) => (
        <div style={{ width: 500, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{ text?.map((item: any) => item?.companyName || item?.name)?.join('，') || '' }</div>
      )
    },
    {
      title: '操作',
      dataIndex: 'actions',
      width: 128,
      render: 'actionRender',
      fixed: 'right',
    },
  ],
  search: [
    {
      name: 'quoteType',
      label: '报价类型',
      itemType: 'select',
      labelKey: 'label',
      key: 'value',
      data: 'budgetTypeList',
    },
  ],
  footer: [
  ],
  batchActions: [],
}
